import { render, staticRenderFns } from "./CFormTextarea.vue?vue&type=template&id=5608d3ec&"
import script from "./CFormTextarea.vue?vue&type=script&lang=js&"
export * from "./CFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports